module.exports = __webpack_public_path__ + "media/images/badges/kinrgy/Kinrgy-50-Classes-Inactive-dbcd70bb2df4640581604b0217c1eb84.png";